import { Component } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { EmailService } from '../services/email/email.service';
import { EmailPromptFormProvider } from './email-prompt-form.provider';

@Component({
  selector: 'ld-email-prompt',
  templateUrl: './email-prompt.component.html',
  styleUrls: ['./email-prompt.component.css'],
  providers: [
    EmailService,
    EmailPromptFormProvider
  ]
})
export class EmailPromptComponent {
  public emailTo = 'CLCustomerService@loandepot.com';
  public shouldCheckIsDirty = true;

  emailPromptForm: FormGroup;

  constructor(
    private api: EmailService,
    private emailPromptFormProvider: EmailPromptFormProvider) {
    this.emailPromptForm = emailPromptFormProvider.getForm();
  }

  sendEmail(): void {
    this.shouldCheckIsDirty = false;
    if (this.emailPromptForm && !this.emailPromptForm.valid) {
      return;
    }
    const firstNameControl = this.emailPromptForm.controls['firstName'];
    const lastNameControl = this.emailPromptForm.controls['lastName'];
    const emailControl = this.emailPromptForm.controls['phone'];
    const phoneControl = this.emailPromptForm.controls['email'];
    const detailsControl = this.emailPromptForm.controls['details'];
    const newline = decodeURIComponent('%0D%0A');
    this.api.openNewEmailMessage({
      to: this.emailTo,
      subject: 'Requesting loanDepot Assistance with Personal Loan Application',
      body: `From: ${ firstNameControl.value } ${ lastNameControl.value }${ newline }` +
      `Email Address: ${ emailControl.value }${ newline }Phone Number: ${ phoneControl.value }` +
      `${ newline }${ newline }Details: ${ detailsControl.value }`
    });
    // this.api.sendHelpEmail()
    //   .subscribe(() => {
    //     window.console.log('Email Sent!');
    //
    //     // TODO: Implement whatever behavior is expected once service email sent
    //   }, (err) => {
    //     window.console.log('sendHelpEmail error:', err);
    //   });
  }
}
